function TabulkyAPomocky(){
    return(
        <div>
      <div className="Section1">         
            <h1 align="center" style={{ textAlign: "center", color: "black" }}>
                Tabuľky a pomôcky
            </h1>         
        <div style={{ textAlign: "center" }}>
          <hr style={{color: "#999999", height: "5px" }} />
        </div>
        

        {/* Obsah z ľavej bunky */}
        <p>
          <i>
            <a href="tabulky/vyhrplyn.mht" target="_blank" rel="noopener noreferrer">
              Tepelno technické charakteristiky základných plynov a pár
              (výhrevnosť, spaľné teplo, molárna hmotnosť)
            </a>
           
          </i>
        </p>
        <p>
          &nbsp;
          <span className="style1">
            <a href="tabulky/Qs-Qn.jpg" target="_blank" rel="noopener noreferrer">
              Výhrevnosť, spaľné teplo
            </a>
            &nbsp;(Hašek)
          </span>
        </p>
        <p>
          &nbsp;
          <span className="style1">
            <a href="tabulky/Qv,Qn STN.pdf" target="_blank" rel="noopener noreferrer">
              Výhrevnosť, spaľné teplo
            </a>
            &nbsp;(STN 38 5509)
          </span>
        </p>
        <p>
          <i>
            Zloženie a vlastnosti zemného plynu (
            <a
              href="https://www.spp-distribucia.sk/dodavatelia/informacie/zlozenie-zemneho-plynu-a-emisny-faktor/"
              target="_blank"
              rel="noopener noreferrer"
            >
              SPP-distribúcia
            </a>
            )
          </i>
        </p>
        <p>
          <i>
            <a
              href="https://www.tzb-info.cz/tabulky-a-vypocty/8-fyzikalni-vlastnosti-vybranych-plynu-a-par"
              target="_blank"
              rel="noopener noreferrer"
            >
              Fyzikálne vlastnosti vybraných plynov a pár
            </a>{" "}
            (TZB-info)
          </i>
        </p>
        <p>
          &nbsp;
          <a href="tabulky/vpav.html" target="_blank" rel="noopener noreferrer">
            <em>Vybrané prvky a ich vlastnosti</em>
          </a>
        </p>
        <p>
          <i>
            Merná tepelná kapacita&nbsp;
            <a href="tabulky/cpm3.DOC" target="_blank" rel="noopener noreferrer">
              &nbsp;objemovú
            </a>
            &nbsp;kJ.m<sup>-3</sup>.K<sup>-1</sup>&nbsp; alebo&nbsp;&nbsp;
            <a href="tabulky/cpkg.DOC" target="_blank" rel="noopener noreferrer">
              hmotnostnú
            </a>
            &nbsp;kJ.kg<sup>-1</sup>.K<sup>-1</sup>
          </i>
        </p>
        <p>
          <i>
            prípadne objemová v publikovanom článku časopisu&nbsp;
            <a
              href="http://atpetjournal.com/papers/Vol6Nb2/ATPET_Prokopchuk.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              ATPET
            </a>&nbsp;
            priamo regresie pre&nbsp;
            <a href="tabulky/cp-plynne paliva.pdf" target="_blank" rel="noopener noreferrer">
              plynná palivá
            </a>
          </i>
        </p>
        <p>
          <i>
            doplnená tabuľky pre plynná palivá&nbsp;
            <a href="tabulky/cp-objemova.pdf" target="_blank" rel="noopener noreferrer">
              plynná palivá+tabuľky
            </a>
          </i>
        </p>
        <p>
          <i>
            Stredná merná tepelná kapacita&nbsp;
            <a
              href="tabulky/tabulky cp_plyny.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              &nbsp;objemovú
            </a>
            &nbsp;kJ.m<sup>-3</sup>.K<sup>-1</sup>&nbsp;(Gurský J.)&nbsp;
          </i>
        </p>
        <p>
          <i>
            <a
              href="https://www.engineeringtoolbox.com/specific-heat-capacity-gases-d_159.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              Specific Heat and Individual Gas Constant of Gases
            </a>&nbsp;
            (The Engineering ToolBox)
          </i>
        </p>
        <p>
          <i>
            <a href="tabulky/dynvisko.DOC" target="_blank" rel="noopener noreferrer">
              Dynamická viskozita
            </a>
          </i>
        </p>
        <p>
          <i>
            <a href="tabulky/krithod.htm" target="_blank" rel="noopener noreferrer">
              Kritické hodnoty tlaku a teplôt niektorých plynov
            </a>
            &nbsp;&nbsp;&nbsp;
            <a href="tabulky/Graf%20Z_1.pdf" target="_blank" rel="noopener noreferrer">
              Graf sýiniteľa stlačiteľnosti-redukované p<sub>r</sub>,T<sub>r</sub>, v
              <sub>r</sub>
            </a>
          </i>
        </p>
        <p>
          <i>
            <a href="tabulky/spalrych.doc" target="_blank" rel="noopener noreferrer">
              Spaľovacie rýchlosti plynov
            </a>
          </i>
        </p>
        <p>
          <i>
            <a href="http://www.mikrotrade.sk/gases/gasesSK.html" target="_blank" rel="noopener noreferrer">
              Medze zápalnosti
            </a>
          </i>
        </p>
        <p>
          <i>
            Diagram&nbsp;
            <a href="tabulky/nh3_1u.pdf" target="_blank" rel="noopener noreferrer">
              p-i NH<span style={{ fontSize: "7.5pt" }}>3</span>
            </a>&nbsp;
            <a href="tabulky/R134a.pdf" target="_blank" rel="noopener noreferrer">
              p-h R134a
            </a>
          </i>
        </p>
        <p>
          <i>
            <a href="tabulky/vlhkost.jpg" target="_blank" rel="noopener noreferrer">
              Diagram pre vlhký vzduch
            </a>
          </i>
        </p>
        <p>
          <i>
            <a href="tabulky/vzduch.jpg" target="_blank" rel="noopener noreferrer">
              Zloženie suchého vzduchu
            </a>
          </i>
        </p>
        <p>
          <i>
            <a href="tabulky/voda.jpg" target="_blank" rel="noopener noreferrer">
              Vlastnosti vody
            </a>&nbsp;
            (&theta;, c)&nbsp;
            <a href="tabulky/vlastnosti%20vody.htm" target="_blank" rel="noopener noreferrer">
              doplnená vlastnosti vody
            </a>&nbsp;
            (c, &theta;, &#955;, &#951;, &#957;, Pr, &#946;)
          </i>
        </p>
        <p>
          <i>
            <a href="tabulky/para.pdf" target="_blank" rel="noopener noreferrer">
              Vodná para
            </a>&nbsp;
            &lt; hustota, entalpia a entrópia pre výpočty vody/vodnej pary
          </i>
        </p>
        <br />

        {/* Obsah z pravej bunky */}
        <p>
          <i>
            <a href="tabulky/lambda.doc" target="_blank" rel="noopener noreferrer">
            Súčiniteľ  tlakovej straty
            </a>
          </i>
        </p>
        <p>
          <i>
            <a href="tabulky/priempe.doc" target="_blank" rel="noopener noreferrer">
              Priemery PE potrubí
            </a>
          </i>
        </p>
        <p>
          <em>
            <span className="style2">Úžitóné informácie a tabuľky</span>&nbsp;
            <a href="https://www.engineeringtoolbox.com/" target="_blank" rel="noopener noreferrer">
              The Engineering ToolBox
            </a>
          </em>
        </p>
        <p>
          <i>
            <a href="tabulky/grectina.gif" target="_blank" rel="noopener noreferrer">
              Grécka abeceda
            </a>
            ,&nbsp;
            <a href="https://web.mit.edu/jmorzins/www/greek-alphabet.html" target="_blank" rel="noopener noreferrer">
              The Greek Alphabet
            </a>
          </i>
        </p>
        <p>
          <i>
            <a href="https://ptable.com/?lang=sk#Vlastnosti" target="_blank" rel="noopener noreferrer">
              Periodická sástava prvkov
            </a>&nbsp;
            (ptable.com)
          </i>
        </p>
        <p>
          <i>
            <a
              href="https://iupac.org/what-we-do/periodic-table-of-elements/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Periodická sástava prvkov
            </a>&nbsp;
            (Aktualizované údaje podľa IUPAC)
          </i>
        </p>
        <p>
          <i>
            Prevody jednotiek&nbsp;
            <a href="http://www.prevody.sk/index.aspx" target="_blank" rel="noopener noreferrer">
              web 1
            </a>&nbsp;
            &nbsp;
            <a href="https://convertlive.com/sk/" target="_blank" rel="noopener noreferrer">
              web 2
            </a>
          </i>
        </p>
        <p>
          <i>
            <a href="http://www.converter.cz/prevody/slovenske-jednotky.htm" target="_blank" rel="noopener noreferrer">
              Prevody jednotiek- staré jednotky
            </a>&nbsp;
            (história)
          </i>
        </p>
        <p>&nbsp;</p>
        <h3>Časopis</h3>
        <p>
          <i>
            <a href="http://atpetjournal.com/" target="_blank" rel="noopener noreferrer">
              Advances in Thermal Processes and Energy Transformation (ATPET)
            </a>
          </i>
        </p>
      </div>
    </div>
    );
};

export default TabulkyAPomocky;